import { NullLogger } from '@fds/wm-typescript-logger';
import get from 'lodash.get';
import merge from 'lodash.merge';
import { getBestFitLocaleTag } from './helpers/locale-tag.js';

const DEFAULT_LOGGER = new NullLogger();
const DEFAULT_BEST_FIT_FLAG = true;
class Translator {
  constructor(configurationOrTranslations, overrides) {
    this.localeTagMap = /* @__PURE__ */ new Map();
    var _a, _b, _c;
    if (Translator.isConfiguration(configurationOrTranslations)) {
      this.translations = this.mergeOverrides(configurationOrTranslations.translations, (_a = configurationOrTranslations.overrides) != null ? _a : {});
      this.logger = (_b = configurationOrTranslations.logger) != null ? _b : DEFAULT_LOGGER;
      this.bestFitFlag = (_c = configurationOrTranslations.bestFit) != null ? _c : DEFAULT_BEST_FIT_FLAG;
    } else {
      this.translations = this.mergeOverrides(configurationOrTranslations, overrides != null ? overrides : {});
      this.logger = DEFAULT_LOGGER;
      this.bestFitFlag = DEFAULT_BEST_FIT_FLAG;
    }
  }
  static isConfiguration(configurationOrTranslations) {
    return configurationOrTranslations.translations !== void 0;
  }
  clone(translations) {
    return JSON.parse(JSON.stringify(translations));
  }
  getLocaleTag(locale) {
    var _a;
    if (!this.bestFitFlag) {
      return locale;
    }
    if (this.localeTagMap.has(locale)) {
      return (_a = this.localeTagMap.get(locale)) != null ? _a : locale;
    }
    const localeTag = getBestFitLocaleTag(locale, Object.keys(this.translations));
    this.localeTagMap.set(locale, localeTag);
    return localeTag;
  }
  mergeOverrides(translations, overrides) {
    const clonedOverrides = this.clone(overrides);
    const clonedTranslations = this.clone(translations);
    Object.keys(clonedOverrides).forEach((locale) => {
      var _a;
      if (!clonedTranslations[locale]) {
        const bestFitLocaleTag = getBestFitLocaleTag(locale, Object.keys(clonedTranslations));
        clonedOverrides[locale] = merge(this.clone((_a = clonedTranslations[bestFitLocaleTag]) != null ? _a : {}), this.clone(clonedOverrides[locale]));
      }
    });
    return merge(clonedTranslations, clonedOverrides);
  }
  translate(key, locale, params) {
    const path = `${this.getLocaleTag(locale)}.${key}`;
    let translatedText = get(this.translations, path, key);
    if (params) {
      translatedText = Object.keys(params).reduce((text, param) => text.replace(new RegExp(`{${param}}`, "ig"), params[param]), translatedText);
    }
    return translatedText;
  }
}

export { Translator };
